<template>
  <div class="py-4 container-fluid">
    <!-- <a class="btn btn-sm btn-primary" style="margin-right: 10px;" :href="apiUrl+'export-excel/rfq?rfq_code='+search.rfq_code+'&vendor_code='+search.vendor_code+'&status='+search.status+''" target="_BLANK"><i class="fa fa-download fa-sm"></i> Export</a> -->
    <!-- <argon-button color="warning" size="sm" class="mb-3" variant="gradient" @click="modalImport()"><i class="fa fa-upload fa-sm"></i> Import</argon-button> -->
    <div class="row">
      <div class="col-lg-3 col-md-6 col-12">
        <card
          title="RFQ Available"
          :value="convertRp(totalTask)"
          iconClass="fa fa-tasks"
          iconBackground="bg-gradient-primary"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <card
          title="CP Draf"
          :value="convertRp(totalCpDraft)"
          iconClass="fa fa-book"
          iconBackground="bg-gradient-secondary"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <card
          title="CP Approved"
          :value="convertRp(totalCpApproved)"
          iconClass="fa fa-thumbs-up"
          iconBackground="bg-gradient-success"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <card
          title="Total CP"
          :value="convertRp(totalCp)"
          iconClass="ni ni-satisfied"
          iconBackground="bg-gradient-warning"
          directionReverse
        ></card>
      </div>
    </div>
    <div class=" row">
      <div class="col-12">
          <div class="card"> 
            <div class="row">
              <div class="col-lg-4">
                <div class="card-header pb-0">
                  <h6>Comparison Price</h6>
                </div>
              </div>
              <div class="col-lg-4">
                <input type="text" class="form-control mt-3" placeholder="Search by Comparison No." v-model="search.cp_no" @keyup="get()">
              </div>
              <div class="col-lg-4 float-right">
                <argon-button
                  style="margin-right: 10px; margin-left: 60px;"
                  class="mt-4"
                  variant="gradient"
                  color="secondary"
                  size="sm"
                  @click="filter()"
                ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="success"
                  size="sm"
                  @click="formSub.title ='==== TRANSACTION COMPARASION PRICE ADD DATA ====', createItem()"
                ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add New</argon-button>
              </div>
            </div>
            
            <div class="card-body px-0 pt-0 pb-2 mt-4">
              <div class="table-responsive p-0 scroll">
                <table class="table table-hover table-striped align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">No</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">COMPARASION NO</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">RFQ NO</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">NOTE</th>
                      <!-- <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">TOTAL ITEM</th> -->
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">STATUS</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">CREATED AT</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">CREATED BY</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in table.data" :key="i">
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ i + 1 }}</span>
                      </td>
                      <td class="align-middle text-center text-sm" @click="getDetailTransaction(row.cp_no, row.safety_code)" style="cursor: pointer;">
                        <span class="badge badge-sm bg-gradient-primary">  {{ row.cp_no }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="badge badge-sm bg-gradient-info">  {{ row.rfq_code }} </span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.note }} </span>
                      </td>
                      <!-- <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase"> {{ row.total_item_count }} </span>
                      </td> -->
                      <td class="align-middle text-center text-sm">
                        <span class="badge badge-sm bg-gradient-success"> {{ row.status }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ moment(row.created_at).locale('id').format('LL') }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.created_by }} </span>
                      </td>
                      <td class="align-middle text-center">
                        <!-- <i class="fa fa-check-circle-o" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="fixData(row.cp_no)"></i> -->
                        <i class="fa fa-trash fa-sm" aria-hidden="true" title="Hapus Comparison Price ini" style="cursor: pointer; margin-right: 20px;" @click="remove(row.id)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <div class="float-right">
                <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL ADD RFQ ======= -->
  <div class="container">
    <vue-final-modal v-model="formAddItem.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formAddItem.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formAddItem.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Search By RFQ NO / MAT SRV GRP </label>
        <input type="text" class="form-control mb-3" placeholder="Keyword : RFQ NO / MAT SRV GRP" @keyup="searchRfqWherePrVendor()" v-model="itemData.vendor">
        <div class="table-responsive p-0 scroll">
          <table class="table align-items-center mb-0">
            <thead>
              <tr style="background-color: #F0F8FF;">
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">No</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Action</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">RFQ NO</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">MAT / SRV GRP</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">DUE DATE</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">NOTE</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">TOTAL ITEM</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">STATUS</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableSearchaRfq.data" :key="i" @click="getDetailTransaction(row.cp_no, row.safety_code)" style="cursor: pointer;">
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ i + 1 }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <i class="fa fa-plus-square text-primary" title="Add Rfq" style="cursor: pointer;" @click="itemData.rfq_code = row.rfq_code, saveItemCp()" disabled></i>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="badge badge-sm bg-gradient-primary">{{ row.rfq_code }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.material_group_code }} - {{ row.group_name }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ moment(row.due_date).locale('id').format('LL') }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.note }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.total_item_count }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="badge badge-sm bg-gradient-info">{{ row.status }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
        </div>
        <div class="col-1">
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- ====================================================================  MODAL PRIVIEW  ============================================================================== -->
  <div class="container">
    <vue-final-modal v-model="formSub.show" classes="modal-container" content-class="modal-content-width" :z-index="10000" :focus-retain="false">
      <!-- header -->
      <div class="row">
        <div class="col-11 text-center">
          <span class="modal__title">{{formSub.title}} <template v-if="headerData.transaction_type">{{ headerData.transaction_type.toUpperCase() }} ====</template></span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formSub.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <div class="row">
          <div class="col-10 text-center">
          </div>
          <div class="col-2 float-right">
            <a class="btn btn-sm btn-warning" style="margin-left: 0px;" :href="apiUrl+'print-pdf/cp-detail?cp_no='+headerData.cp_no+''" target="_BLANK"><i class="fa fa-print fa-sm"></i> Print</a>
          </div>
        </div>
        <table class="table table-sm table-bordered">
          <tbody>
            <tr v-if="headerData.cp_no != undefined">
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> COMPARASION NUMBER </td>
              <td colspan="4"> <input type="text" class="form-control" placeholder="PR NO" v-model="headerData.cp_no" disabled> </td>
            </tr>
            <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> RFQ NUMBER </td>
              <td colspan="4"> <input type="text" class="form-control" placeholder="PR NO" v-model="headerData.rfq_no" disabled> </td>
            </tr>
            <!-- <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> VENDOR CODE <span style="color: red;">*</span></td>
              <td colspan="3"> 
                <multiselect v-model="headerData.vendor_code" :options="tableVendor.data" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Vendor Code" label="vendor_code" track-by="vendor_code" :preselect-first="true" @keyup="getVendor" :custom-label="nameWithLangVendor">
                  <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
                </multiselect> 
              </td>
            </tr> -->
            <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> DUE DATE <span style="color: red;">*</span></td>
              <td> <input type="date" class="form-control" placeholder="Due Date" v-model="headerData.due_date" disabled> </td>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> STATUS <span style="color: red;">*</span></td>
              <td> <input type="text" class="form-control" placeholder="Status" v-model="headerData.status" disabled> </td>
            </tr>
            <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> NOTE </td>
              <td colspan="4"> <input type="text" class="form-control" placeholder="General Note" v-model="headerData.note" disabled> </td>
            </tr>
          </tbody>
        </table>
          <!-- ===== FOR ITEM LIST ===== -->
          <div>
            <div class="">
              <hr style="border: 2px solid #008000;">
              <div class="row mb-2">
                <div class="col-4">
                  <div class="card-header pb-0">
                    <h6><i class="fas fa-list-ol" style="margin-right: 10px;"></i> Item List</h6>
                  </div>
                </div>
                <div class="col-5">
                </div>
                <div class="col-3 float-right" v-if="headerData.cp_no != undefined">
                  <argon-button
                    style="margin-right: 10px; margin-left: 60px;"
                    class="mt-4"
                    variant="gradient"
                    color="warning"
                    size="sm"
                    :disabled="headerData.status == 'CP Approved'"
                    @click="cpApproved(headerData.rfq_no, headerData.safety_code)"
                  ><i class="fa fa-check-circle-o" aria-hidden="true"></i> CP Approved</argon-button>
                </div>
              </div>
              <div class="table-responsive p-0 scrollHeighAuto">
                <table class="table table-hover table-striped align-items-center mb-0">
                  <thead>
                    <tr style="background-color: #F0F8FF;">
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">No</th>
                      <!-- <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Image</th> -->
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PR Code</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Part Name</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Specification</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Size</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Unit</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Qty</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Weight</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">MPS NO</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ITEM NO</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">USE FOR</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">STATUS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in dataListItem.data" :key="i">
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ i + 1 }}</span>
                      </td>
                      <!-- <td class="align-middle text-center text-sm">
                        <img
                          :src="storageUrl+'/image_warehouse/'+row.image"
                          class="avatar avatar-lg me-1"
                          alt="user1"
                        />
                      </td> -->
                      <td class="align-middle text-center text-sm">
                        <span class="badge badge-sm bg-gradient-primary">  {{ row.pr_code }} <span v-if="row.total_revision"> (Rev. {{ row.total_revision }})</span></span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.part_name }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.specification }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.size }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.unit }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.qty }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.weight }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.mps_no }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.item_no }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.use_for }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="badge bg-gradient-info">{{ row.status }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- LIST VENDOR YANG SUDAH MENGISI HARGA -->
              <div class="row mb-2 mt-5">
                <div class="col-4">
                  <div class="card-header pb-0">
                    <h6><i class="fas fa-list-ol" style="margin-right: 10px;"></i> Vendor List</h6>
                  </div>
                </div>
                <div class="col-3">
                </div>
                <div class="col-5 float-right">
                </div>
              </div>
              <div class="table-responsive p-0 scrollHeighAuto">
                <table class="table table-hover table-striped align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">No</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Vendor</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Part Name</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Specification</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Size</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Qty</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Unit Price</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Amount</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Other Cost</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Other Cost Description</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Discount</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Price</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Del Condition</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Del Time</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Payment Terms</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Manufacture</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Remark</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in dataListVendor.data" :key="i">
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ i + 1 }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.company_name }}</span>
                  <span class="badge badge-sm bg-gradient-danger ms-1" v-if="row.vendor_status == 'Blacklist'" title="Vendor ini berstatus BLACKLIST di Vendor Management">Blacklist</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.part_name }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.specification }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.size }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.qty }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ convertRp(row.unit_price) }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ convertRp(row.amount) }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ convertRp(row.other_cost) }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ convertRp(row.other_cost_description) }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ convertRp(row.discount) }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.price }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.del_condition }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ moment(row.del_time).locale('id').format('LL') }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.payment_terms }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.manufacture }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.remark }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
        </div>
        <div class="col-1">
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- ================================================  MODAL FILTER ============================================== -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilter.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Comparasion No </label>
        <input type="text" class="form-control" placeholder="Comparasion No" v-model="search.cp_no" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">RFQ No </label>
        <input type="text" class="form-control" placeholder="RFQ No" v-model="search.rfq_code" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Note </label>
        <input type="text" class="form-control" placeholder="Note" v-model="search.note" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Status </label>
        <select class="form-select" aria-label="Default select example" v-model="search.project_type">
          <option value="Draf">Draf</option>
          <option value="RFQ approved">RFQ approved</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Date Range</label> 
        <flat-pickr :config="{ mode: 'range',}" class="form-control mb-4" v-model="search.date"/>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="search = {}">Clear</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="get()" :disabled="onLoading">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span>Filter</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

</template>

<script>
import Card from "@/examples/Cards/Card.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import BasePagination from "@/components/BasePagination";
import Api from '@/helpers/api';
import config from '@/configs/config';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
// import Multiselect from 'vue-multiselect'
// import 'vue-multiselect/dist/vue-multiselect.css';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
var moment = require('moment');
import comparasionPrice from '@/services/procurement/comparasionPrice.service';
import requestForQuotation from '@/services/procurement/requestForQuotation.service';
import purchasingRequisition from '@/services/procurement/purchasingRequisition.service';
import vendorList from '@/services/procurement/vendorList.service';

export default {
  name: "tables",
  components: {
    Card,
    ArgonButton,
    VueFinalModal,
    // Multiselect,
    BasePagination,
    flatPickr,
  },
  data() {
    return {
      pagination: {
        page_count: '',
        page: 1,
      },
      moment:moment,
      table: {
        data: []
      },
      totalTask: '',
      totalCpDraft: '',
      totalCpApproved: '',
      totalCp: '',
      formSub: {
        add: true,
        title: "==== TRANSACTION COMPARASION PRICE DETAIL ====",
        show: false
      },
      formAddItem: {
        add: true,
        title: "==== TRANSACTION COMPARASION PRICE DETAIL ====",
        show: false
      },
      formAddDetailItem: {
        add: true,
        title: "Add Detail Item",
        show: false
      },
      formImport: {
        add: true,
        title: "Import Data Setting Approval",
        show: false
      },
      formFilter: {
        add: true,
        title: "Filter",
        show: false
      },
      onLoading: false,
      storageUrl : config.storageUrl,
      headerData: {},
      search: {
        cp_no: '',
        rfq_code: '',
        note: '',
        status: '',
        date: '',
      },
      apiUrl :config.apiUrl,
      tablePr: {
        data: []
      },
      tableSearchaRfq: {
        data: []
      },
      tableItem: {
        data: []
      },

      // ----- Item Transaction COMPARASION PRICE -----
      dataTransaction: {},
      dataListItem: {
        data: []
      },
      dataListVendor: {
        data: []
      },
      itemData: {},
    };
  },
  mounted(){
    this.get();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
  },
  methods: {
    nameWithLangPr ({ pr_code }) {
      return `${pr_code}`
    },
    get(param){
      let context = this; 
      context.onLoading = true;

      Api(context, comparasionPrice.index({cp_no: this.search.cp_no, rfq_code: this.search.rfq_code, note: this.search.note, status: this.search.status, date: this.search.date, page: context.pagination.page})).onSuccess(function(response) {    
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page

          context.totalTask       = response.data.data.task;
          context.totalCpDraft    = response.data.data.cpDraft;
          context.totalCpApproved = response.data.data.cpApproved;
          context.totalCp         = response.data.data.totalCp;

          // context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.formFilter.show = false;
         context.onLoading       = false;
      })
      .call()
    },
    getPrNo(param){
      if (param.target.value.length >= 3) {
        let context = this;        
        Api(context, purchasingRequisition.getPrNo({search: param.target.value})).onSuccess(function(response) {    
            context.tablePr.data = response.data.data;
        }).onError(function(error) {                    
            if (error.response.status == 404) {
                context.tablePr.data = [];
            }
        }).onFinish(function() { 
        })
        .call()
      }
    },
    searchRfqWherePrVendor(){
      let context = this;              
      Api(context, requestForQuotation.searchRfqWherePrVendor({search: context.itemData.vendor})).onSuccess(function(response) {   
          context.tableSearchaRfq.data = response.data.data;
      })
      .call()
    },
    getDetailTransaction(cpNo, safetyCode){
      let context = this; 

      Api(context, requestForQuotation.transactionDetail({safety_code: safetyCode, page: ''})).onSuccess(function(response) {    
          context.headerData.id          = response.data.data.data.id;
          context.headerData.rfq_no      = response.data.data.data.rfq_code;
          context.headerData.safety_code = response.data.data.data.safety_code;
          context.headerData.due_date    = response.data.data.data.due_date;
          context.headerData.note        = response.data.data.data.note;
          context.headerData.status      = response.data.data.data.status;

          context.headerData.vendor_code = response.data.data.dataVendor;

          context.dataListItem.data   = response.data.data.dataListItem;
          context.dataListVendor.data = response.data.data.dataListVendor;

          context.formSub.add   = true;
          context.formSub.show  = true;
          context.formSub.title = "==== TRANSACTION COMPARASION PRICE DETAIL ====";

          context.headerData.cp_no = cpNo;
          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.headerData = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
      })
      .call()

      // let context = this;               
      // Api(context, comparasionPrice.transactionDetail({cp_no: trxnumber})).onSuccess(function(response) {    
      //     context.headerData.id       = response.data.data.data.id;
      //     context.headerData.cp_no    = response.data.data.data.cp_no;
      //     context.headerData.note     = response.data.data.data.note;
      //     context.headerData.status   = response.data.data.data.status;

      //     context.headerData.pr_no = response.data.data.dataPr;

      //     context.dataListItem.data = response.data.data.dataListItem;

      //     context.formSub.add   = true;
      //     context.formSub.show  = true;
      //     context.formSub.title = "==== TRANSACTION COMPARASION PRICE DETAIL ====";

      //     context.notify('Data Retrieved Successfully', 'success')
      // }).onError(function(error) {                    
      //     if (error.response.status == 404) {
      //         context.headerData = [];
      //     }
      //     context.notify('Data Retrieved Failed', 'error')
      // }).onFinish(function() { 
      // })
      // .call()
    },
    filter() {
      this.formFilter.add   = true;
      this.formFilter.show  = true;
      this.formFilter.title = "Filter";
      this.onLoading        = false;
      this.pagination.page  = 1 ;
    },
    createWithSubForm() {
      this.formSub.add       = true;
      this.formSub.show      = true;
      this.formSub.title     = "==== TRANSACTION COMPARASION PRICE ADD DATA ====";
      this.headerData        = {};
      this.headerData.status = 'Draf',
      this.dataListItem.data = {}
      // this.generateCPNo()
      // this.defaultDate()
    },
    createItem() {
      this.formAddItem.add   = true;
      this.formAddItem.show  = true;
      this.formAddItem.title = "Add Item";
      this.itemData          = {};
      this.itemData.vendor   = ''
      if (this.formSub.title != "==== TRANSACTION COMPARASION PRICE DETAIL ====") {
        this.generateCPNo()
        this.headerData        = {};
        this.headerData.status = 'Draf'
        this.dataListItem.data = {}
      }
      this.searchRfqWherePrVendor()
    },
    // createItemDetail() {
    //   this.formAddDetailItem.add   = true;
    //   this.formAddDetailItem.show  = true;
    //   this.formAddDetailItem.title = "Add Detail Item";
    //   // this.itemData                = {};
    // },
    editItem(id) {
      let context = this;               
      Api(context, comparasionPrice.showItem(id)).onSuccess(function(response) {
          context.itemData          = response.data.data;
          context.itemData.id_item  = response.data.data.id;
          context.formAddItem.show  = true;
          context.formAddItem.title = 'Edit Data';   
      })
      .call()        
    },
    filesChange(e) {
      this.headerData.attachment = e.target.files[0];
    },
    generateCPNo(){
      let context = this;              
      Api(context, comparasionPrice.generateCPNo()).onSuccess(function(response) {   
          context.headerData.cp_no = response.data.data;
      })
      .call()
    },
    saveItemCp(id){
      let api      = null;
      let context  = this;
      let formData = new FormData();

      // INSERT HEADER
      if (context.headerData.cp_no != undefined && context.itemData.rfq_code != undefined && context.headerData.status != undefined) {
        formData.append('cp_no', context.headerData.cp_no);
        formData.append('rfq_code', context.itemData.rfq_code);
        formData.append('status', 'Draf');
        formData.append('note', (context.headerData.note == undefined) ? '-' : context.headerData.note);
        // id item pr
        // formData.append('rfq_item_code', context.itemData.rfq_item_code);
        // formData.append('pr_item_code', context.itemData.pr_item_code);
        // formData.append('unit_price', context.itemData.unit_price);
        // formData.append('discount', (context.itemData.discount == undefined) ? '' : context.itemData.discount);
        // formData.append('remark', (context.itemData.remark == undefined) ? '-' : context.itemData.remark);
        // formData.append('price', context.itemData.price);
        // formData.append('del_condition', context.itemData.del_condition);
        // formData.append('del_time', context.itemData.del_time);
        // formData.append('payment_terms', context.itemData.payment_terms);
        // formData.append('manufacture', context.itemData.manufacture);
      }else{
        return alert('The Red Star Field is Mandatory')
      }

      if (context.formSub.title == '==== TRANSACTION COMPARASION PRICE ADD DATA ') {
          api = Api(context, comparasionPrice.create(formData));
      } else {
          api = Api(context, comparasionPrice.create(formData));
      }
      api.onSuccess(function(response) {
        context.notify((context.formSub.title === '==== TRANSACTION COMPARASION PRICE ADD DATA ') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      }).onError(function(error) { 
        context.notify((context.formSub.title != '==== TRANSACTION COMPARASION PRICE ADD DATA ') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() { 
        context.searchRfqWherePrVendor() 
        // context.getDetailTransaction(context.headerData.cp_no);
        context.get();
        context.generateCPNo();
        context.formSub.show  = false;
      })
      .call();
    },
    remove(id) {
      var r = confirm("Are you sure you want to delete this data ?");
      if (r == true) {
        let context = this;
        Api(context, comparasionPrice.delete(id)).onSuccess(function(response) {
          context.get();
          context.notify('Data Successfully Deleted', 'success')
        }).call();
      }
      this.formSub.show  = false;
      this.formAddItem.show  = false;
    },
    cpApproved(param, safetyCode){
      let api      = null;
      let context  = this;
      api = Api(context, comparasionPrice.cpApproved({rfq_code: param}));
      api.onSuccess(function(response) {
        context.get();
        context.getDetailTransaction(context.headerData.cp_no, safetyCode)
        context.notify((context.form === 'Add Data') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      }).onError(function(error) { 
        context.notify((context.form != 'Add Data') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {  
      })
      .call();
    },
    defaultDate(){
      var date  = new Date();
      var day   = ("0" + date.getDate()).slice(-2);
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var today = date.getFullYear() + "-" + (month) + "-" + (day);

      this.headerData.date = today
    },
    changePage(page){
      this.pagination.page = page;
      this.get();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }
    },
    convertRp(bilangan) {
      if (bilangan) {
        // var number_string = bilangan.toString(),
        //     sisa    = number_string.length % 3,
        //     rupiah  = number_string.substr(0, sisa),
        //     ribuan  = number_string.substr(sisa).match(/\d{3}/g);

        // if(ribuan){
        //   var separator = sisa ? '.' : '';
        //   rupiah += separator + ribuan.join('.');
        //   return rupiah
        // }else{
        //   return bilangan
        // }

        var data =  Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR"
        }).format(bilangan);
        
        return data.substr(3)
      }

    },

  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
/*MODAL WIDTH KUSUS LEBAR BESAR*/
::v-deep .modal-content-width {
  /*display: flex;*/
  /*flex-direction: column;*/
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 1090px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll { 
  overflow: auto; 
  height: 500px; 
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED;
}
.scrollHeighAuto { 
  overflow: auto; 
  height: auto; 
}
.scrollHeighAuto thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED;
}

::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
}

::-webkit-scrollbar {
    height: 10px;
    background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: red;
}
</style>
